import styled from 'styled-components'
import Chart from 'react-apexcharts'
import Text from '../../atoms/Text'
import PieChart from '@mui/icons-material/PieChartRounded';

const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color:${(props) => props.theme.colors.neutral[100]};
  border-radius: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral[300]};
  margin-top: 8px;
`
const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`
const StyledChart = styled(Chart)`
  // 높이의 절반인 8px 적용
  clip-path: inset(0% 0% 0% 0% round 8px);
  -webkit-clip-path: inset(0% 0% 0% 0% round 8px);
`
const DataLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`
const ParticipationRateCard = ({ child }) => {
  const parent = 100 - child;
  const chartData = {
    series: [
      { name: '아이', data: [child] },
      { name: '보호자', data: [parent] }
    ],
    options: {
      chart: {
        type: 'bar',
        stacked: true, // 여러 데이터를 쌓아서 표시
        stackType: '100%', // 합계가 100%가 되도록 자동 비중 계산
        sparkline: { enabled: true },
        toolbar: { show: false },
        animations: {enabled: false }
      },
      plotOptions: {
        bar: {
          horizontal: true, // 가로 방향으로 렌더링
          barHeight: '100%', // 컨테이너 높이를 꽉 채움
        },
      },
      colors: ['#60A5FA', '#F7F7F7'], // 아이(파랑), 보호자(회색) 색상
      // stroke: { width: 0 }, // 바 사이의 경계선 제거
      tooltip: { enabled: false }, // 툴팁 비활성화
      states: {
        hover: {
          filter: { type: 'none' } // 마우스 올려도 어두워지거나 밝아지지 않음
        },
        active: {
          filter: { type: 'none' } // 클릭해도 색상 유지
        }
      }
    }
  };

  return (
    <Container>
      <Title>
        <PieChart sx={{ fontSize: 24, color: '#60A5FA'}}/>
        <Text variant="body2" color="alternative">대화 참여율</Text>
      </Title>
      <DataLabel>
        <Text weight="medium" color="#60A5FA">아이 {child}%</Text>
        <Text weight="medium" color="assistive" >보호자 {parent}%</Text>
      </DataLabel>
      <StyledChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={16}
      />
    </Container>
  )
}

export default ParticipationRateCard
